import React, { useEffect, useState } from "react";

import {
  getAnalyticsConsent,
  initializeAnalytics,
  setAnalyticsConsent,
} from "../utils/analytics";

import "../styles/AnalyticsConsent.css";

const AnalyticsConsent = () => {
  const [consent, setConsent] = useState(getAnalyticsConsent());

  useEffect(() => {
    if (consent === "granted") {
      initializeAnalytics();
    }
  }, [consent]);

  if (consent) return null;

  const handleDecision = (value) => {
    setAnalyticsConsent(value);
    setConsent(value);
  };

  return (
    <div className="c-analytics-consent" role="region" aria-label="Zgoda analityczna">
      <p>
        Używamy anonimowych narzędzi analitycznych, żeby ulepszać test i raport
        Jobbli. Nie wysyłamy do nich treści raportu ani danych płatności.
      </p>
      <div className="c-analytics-consent__actions">
        <button
          type="button"
          className="c-btn c-btn--small-size c-btn--blue-color"
          onClick={() => handleDecision("granted")}
        >
          Akceptuję
        </button>
        <button
          type="button"
          className="c-btn c-btn--small-size c-btn--dark-blue-color"
          onClick={() => handleDecision("denied")}
        >
          Odmawiam
        </button>
      </div>
    </div>
  );
};

export default AnalyticsConsent;
